export default __webpack_public_path__ + "static/media/downActive.74019f91.svg";